import React from "react";
import { withStyles } from "@material-ui/styles";
import { Grid, Button, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import MediaQuery from "react-responsive";
import { useMediaQuery } from "react-responsive";
import theme from "../../Theme";

function NoReviews(props) {
  const { classes, companyName, openForm } = props;

  const isMobileLayout = useMediaQuery({
    query: "(max-width: 700px)",
  });

  const isTabletLayout = useMediaQuery({
    query: "(max-width: 960px)",
  });

  const Body = () => (
    <div className={classes.container}>
      <Grid container className={classes.formBoxContent}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5" className={classes.textStyle} gutterBottom>
            Remote Worker Reviews
          </Typography>
          <Typography
            className={classes.textStyle}
            gutterBottom
            variant="body2"
          >
            {`We don't yet have employee reviews from ${companyName}. If you have experience working with ${companyName}, we'd greatly appreciate a submission. You will also be entered to win a pair of Apple Airpods Pro`}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.btnContainer}>
          <Button
            variant="contained"
            color="primary"
            // size="small"
            // className={classes.button}
            onClick={openForm}
            style={{ marginTop: 15 }}
            // startIcon={<AddCircleOutlineIcon />}
          >
            Add a Review
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <Grid className={classes.mobileCard}>
      <Body />
    </Grid>
  );
}

const styles = (theme) => ({
  container: {
    width: "100%",
    textAlign: "left",
    // "& p": {
    //     fontFamily: "Roboto,Helvetica,Arial, sans-serif",
    //     letterSpacing: ".4px",
    //     fontSize: "1rem",
    //     lineHeight: "20px",
    // },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 30px",
    [theme.breakpoints.down("sm")]: {
      margin: 0,
    },
    //maxWidth: "700px",
  },
  button: {
    marginTop: "15px",
    marginLeft: "auto",
    marginRight: "auto",
    margin: "0 30px",
  },
  mobileCard: {},
  desktopContainer: {
    paddingLeft: "30px",
  },
  formBoxContent: {},
  textStyle: {
    fontWeight: 400,
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  btnContainer: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
});

export default withStyles(styles)(NoReviews);
